"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _isArray = _interopRequireDefault(require("lodash/isArray"));
var _queryString = _interopRequireDefault(require("query-string"));
var _reactRouterDom = require("react-router-dom");
var _UiContext = _interopRequireDefault(require("../context/UiContext"));
var _getObjectDifferences = _interopRequireDefault(require("../utils/getObjectDifferences"));
var _searchParamsToObject = _interopRequireDefault(require("../utils/searchParamsToObject"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const useFilter = (refForm, defaults, resetParamsAfterFilter) => {
  var _ui$_location;
  const [ui] = (0, _react.useContext)(_UiContext.default);
  const [filter, setFilter] = (0, _react.useState)({});
  const prevURLSearchParams = (0, _react.useRef)({});
  const location = (0, _reactRouterDom.useLocation)();
  const urlParams = _queryString.default.parse(location.search);
  const navigate = (0, _reactRouterDom.useNavigate)();
  (0, _react.useEffect)(() => {
    const searchParams = new URLSearchParams({
      ...urlParams
    });
    searchParams.sort();
    const searchParamsObject = (0, _searchParamsToObject.default)(searchParams);

    // save prev searchParams

    prevURLSearchParams.current = searchParamsObject;
    setFilter({
      ...defaults,
      ...searchParamsObject
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ui === null || ui === void 0 || (_ui$_location = ui._location) === null || _ui$_location === void 0 ? void 0 : _ui$_location.search]);
  (0, _react.useEffect)(() => {
    var _refForm$current;
    if ((refForm === null || refForm === void 0 || (_refForm$current = refForm.current) === null || _refForm$current === void 0 ? void 0 : _refForm$current.getAttribute("data-useFilter")) === null) {
      var _refForm$current2;
      refForm.current.setAttribute("data-useFilter", "");
      refForm === null || refForm === void 0 || (_refForm$current2 = refForm.current) === null || _refForm$current2 === void 0 || _refForm$current2.addEventListener("submit", e => {
        e.preventDefault();
        const searchParams = new URLSearchParams(new FormData(refForm === null || refForm === void 0 ? void 0 : refForm.current));
        searchParams.sort();
        const searchParamsObject = (0, _searchParamsToObject.default)(searchParams);

        // check if resetParamsAfterFilter essential

        if ((0, _isArray.default)(resetParamsAfterFilter) && resetParamsAfterFilter.length > 0) {
          const differences = (0, _getObjectDifferences.default)(searchParamsObject, prevURLSearchParams.current);
          if (differences.length > 0) {
            resetParamsAfterFilter.forEach(param => {
              const paramKey = Object.keys(param)[0];
              const paramValue = Object.values(param)[0];
              if (differences.indexOf(paramKey) === -1) {
                searchParamsObject[paramKey] = paramValue;
              }
            });
          }

          // save prev searchParams

          prevURLSearchParams.current = searchParamsObject;
        }

        // generate new URLSearchParams
        // to avoid multiple params
        // old: &location=Kitzbühel&location=Oberndorf
        // new: &location=Kitzbühel,Oberndorf

        const newSearchParams = new URLSearchParams();
        for (const key in searchParamsObject) {
          if (searchParamsObject[key]) {
            newSearchParams.append(key, searchParamsObject[key]);
          }
        }

        // add PreviewToken param if exists in url params

        if (urlParams !== null && urlParams !== void 0 && urlParams.PreviewToken) {
          newSearchParams.append("PreviewToken", urlParams === null || urlParams === void 0 ? void 0 : urlParams.PreviewToken);
        }
        navigate("?" + newSearchParams);
      });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refForm.current]);
  return filter;
};
var _default = exports.default = useFilter;